import { CommonModule } from '@angular/common';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { CalendarOptions } from '@fullcalendar/core';
import { FullCalendarComponent, FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import { SidebarModule } from 'primeng/sidebar';
import { DialogModule } from 'primeng/dialog';
import { PropertyService } from '../properties/service/property.service';
import { MessageService } from 'primeng/api';
import { Status } from 'src/app/core/shared/interface';
import { CreateToursComponent } from '../create-tour/create-tours.component';
import { MessageConversationComponent } from './message-conversation/message-conversation.component';
import { TemplateService } from '../templates/templates.service';
import { ConversationRole } from '../../constants/conversation-roles.constant';
import { SharedModule } from '../../core/shared/shared.module';
import { TourService } from './tour.service';
import { TourChannel, TourStatus } from '../../enums/tour-statuses.enum';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { BlackoutService } from '../properties/service/blackout.service';
import { TooltipModule } from 'primeng/tooltip';
import interactionPlugin from '@fullcalendar/interaction';
import { toZonedTime, format } from 'date-fns-tz';
import { addHours } from 'date-fns';
import moment from 'moment';
import { forkJoin, Subscription } from 'rxjs';
import { InternalNote, TourMetaService } from './tour-meta.service';
import { ChatLogService } from '../chat-logs/chat-log.service';
@Component({
    selector: 'app-followups',
    standalone: true,
    imports: [
        TableModule,
        CommonModule,
        DropdownModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        CalendarModule,
        SidebarModule,
        DialogModule,
        ReactiveFormsModule,
        CreateToursComponent,
        MessageConversationComponent,
        SharedModule,
        ToastModule,
        TagModule,
        TooltipModule,
        FullCalendarModule
    ],
    templateUrl: './followups.component.html',
    styleUrls: ['./followups.component.scss'],
    providers: [MessageService]
})
export class FollowupsComponent implements OnInit {
    @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
    @ViewChild('tenantCalendar') tenantCalendarComponent!: FullCalendarComponent;
    calendlyLink: string = '';
    showLinkDialog: boolean = false;
    followUps: any[] = [];
    propertyId = "6724ec85459e3cdf8db55149";
    totalRecords: number = 0;
    rowsPerPage: number = 10;
    currentPage: number = 0;
    filters: any = {
        plan_name: null,
        user_id: null,
        status: null,
        appointmentDate: null,
        lead_source: null,
        search: ''
    };
    sorting: any = {
        field: '',
        order: 1
    };
    planNames: any[] = [];
    agents: any[] = [];
    statuses: any[] = [];
    leadSources: any[] = [];

    displaySidebar: boolean = false;
    showCancelDialog: boolean = false;
    showDeleteDialog: boolean = false;
    followupToDelete: any = null;
    
    newFollowupForm: FormGroup;
    propertyDetails: any = {};
    userInfo: any = null;
    propTimeZone: string = '';
    position: 'center' | 'right' = 'center';
    visible: boolean = false;
    selectedTour: any | null = null;
    isOpen: boolean = false;
    isLoading: boolean = false;
    isSystemConversation: boolean = true;
    blockSpecialCharsPattern = /[.*+?^${}()|[\]\\]/g;
    cancelTourDialog: boolean = false;
    tourToCancel: any = null;
    isCancelling: boolean = false;
    isConfirmLoading: boolean = false;
    rescheduleTourDialog: boolean = false;
    headerText: string = 'Create';
    
    // Blackout properties
    blackouts: any[] = []; // List of blackouts for the property
    selectedBlackoutDate: string | null = null;
    showBlackoutDialog: boolean = false;
    isFullDayBlackout: boolean = true;
    blackoutStartTime: Date | null = null;
    blackoutEndTime: Date | null = null;
    blackoutStartTimeStr: string | null = null;
    blackoutEndTimeStr: string | null = null;
    blackoutReasonType: 'holiday' | 'maintenance' | 'closure' | 'other' = 'other';
    blackoutReasonText: string = '';
    editingBlackoutId: string | null = null;
    minDate = new Date();
    blackoutTypes = [
        { label: 'Full Day', value: true },
        { label: 'Specific Time', value: false },
    ];
    calendarOptions: CalendarOptions = {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        dayMaxEvents: 2,
        moreLinkContent: (args) => ({ html: `<span class="more-slots-link">+${args.num} more</span>` }),
        dateClick: (info) => {
            const clicked = moment(info.dateStr).format('MM/DD/YYYY');
            const blackoutsOnDate = this.blackouts.filter(b => b.date === clicked);

            if (this.isTenant) {
                if (moment(clicked, 'MM/DD/YYYY').isBefore(moment(), 'day')) return;
                // Block only if landlord has a FULL-DAY blackout; specific-time allows tenant to still add
                if (blackoutsOnDate.some(b => !b.userId && b.isFullDay)) return;
                // Block if tenant already has their own full-day blackout — delete it first
                if (blackoutsOnDate.some(b => b.userId && b.isFullDay)) return;
                this.onBlackoutDateSelect(clicked);
            } else {
                // Landlord: no adding if a landlord blackout already exists for this date
                if (blackoutsOnDate.some(b => !b.userId)) return;
                this.onBlackoutDateSelect(clicked);
            }
        },
        eventTimeFormat: {
            hour: '2-digit',
            minute: '2-digit',
            meridiem: true,
            hour12: true,
        },
        weekends: true,
        showNonCurrentDates: false,
    };
    showBalckoutDeleteDialog = false;
    blackoutIdToDelete: string | null = null;
    tags: any[] = [];
    tag = '';
    tagColor = '#2196f3';
    internalNote = '';
    showBlackoutSection = false;
    userType: string = '';
    private metaSub!: Subscription;

    get isTenant(): boolean {
        return this.userType === 'tenant';
    }
    constructor(
        private fb: FormBuilder,
        private propertyService: PropertyService,
        private router: Router,
        private messageService: MessageService,
        private templateService: TemplateService,
        private tourService: TourService,
        private blackoutService: BlackoutService,
        private tourMetaService: TourMetaService,
        private chatLogService: ChatLogService,
    ) {
        this.newFollowupForm = this.fb.group({
            customer_name: ['', Validators.required],
            customer_email: ['', [Validators.email]],
            phone_number: ['', Validators.required]
        });
        const decoded = this.propertyService.getDecodedToken();
        this.userType = decoded?.user_type || '';
    }

    ngOnInit(): void {
        this.getPropertyDetails();
        this.propertyService.getUserInfo().subscribe(user => {
            this.userInfo = user;
            this.propertyId = user.property_id;
            this.propTimeZone = this.userInfo.property.timezone;
            if (!this.isTenant) {
                this.loadFilters();
            } else {
                this.loadTenantFilters();
            }
            console.log('this.propTimeZone', this.propTimeZone)
            this.calendarOptions = {
                ...this.calendarOptions,
                timeZone: this.propTimeZone
            };
            if (!this.isTenant && this.calendarComponent) {
                const calendarApi = this.calendarComponent.getApi();
                calendarApi.setOption('timeZone', this.propTimeZone);
                calendarApi.render();
            }
            if (!this.isTenant) {
                this.loadBlackouts();
            }
        });

        this.metaSub = this.tourMetaService.metaUpdated$.subscribe(update => {
            // 🔥 IMPORTANT: match correct field
            const tour = this.followUps.find(f => f._id === update.tourId);
            // OR if needed:
            // const tour = this.followUps.find(f => f.tour_id === update.tourId);

            if (tour) {
                tour.tourMeta = {
                ...(tour.tourMeta || {}),
                ...update
                };
            }
        });
    }

    ngOnDestroy() {
        if (this.metaSub) {
            this.metaSub.unsubscribe();
        }
    }
    
    ngAfterViewInit(): void {
        if (!this.isTenant && this.calendarComponent) {
            const calendarApi = this.calendarComponent.getApi();
            calendarApi.setOption('timeZone', this.propTimeZone);
            calendarApi.render();
        }
    }

    loadFilters(): void {
        this.propertyService.getAllFollowups({ page: 1, limit: 1000 }).subscribe({
            next: (response) => {
                this.propertyService.getVisibleUnits(this.propertyId, { limit: 1000 }).subscribe(res => {
                    this.planNames = res.data.map((plan: any) => ({
                        label: plan.unit,
                        value: plan.unit
                    })).sort((a: any, b: any) => {
                        const aIsNum = /^\d+$/.test(a.label);
                        const bIsNum = /^\d+$/.test(b.label);
                        if (aIsNum && bIsNum) return Number(a.label) - Number(b.label);
                        if (aIsNum) return 1;
                        if (bIsNum) return -1;
                        return a.label.localeCompare(b.label);
                    });
                });

                this.propertyService.getTenants({}).subscribe(res => {
                    this.agents = res.data.map((tenant: any) => ({
                        label: tenant.first_name + ' ' + tenant.last_name,
                        value: tenant._id
                    }));
                    this.agents.sort((a: any, b: any) => a.label.localeCompare(b.label));
                    this.agents.push({ label: 'To Be Assigned', value: 'unassigned' });
                });

                this.statuses = Object.values(Status).map(status => ({
                    label: status,
                    value: status
                }));
                this.statuses.sort((a: any, b: any) => a.label.localeCompare(b.label));

                this.tourService.getLeadSources(this.propertyId).subscribe({
                    next: (sources) => {
                        this.leadSources = sources.map(s => ({ label: s, value: s }));
                    }
                });
            },
            error: (error) => {
                console.error('Error loading filter data:', error);
            }
        });
    }

    loadTenantFilters(): void {
        this.propertyService.getVisibleUnits(this.propertyId, { limit: 1000 }).subscribe({
            next: (res) => {
                this.planNames = res.data.map((plan: any) => ({
                    label: plan.unit,
                    value: plan.unit
                }));
            }
        });
        this.statuses = Object.values(Status).map(status => ({
            label: status,
            value: status
        }));
    }

    getPropertyDetails() {
        this.propertyService.getPropertyDetails().subscribe(res => {
            this.propertyDetails = res
        });
    }

    resetFilters(): void {
        this.filters = {
            plan_name: null,
            user_id: null,
            status: null,
            appointmentDate: null,
            lead_source: null,
            search: ''
        };
        this.onFilterChange();
    }

    generateCalendlyLink(followup: any): string {
        const name = encodeURIComponent(followup.customer_name);
        const email = encodeURIComponent(followup.customer_email);
        const a1 = encodeURIComponent(`${this.propertyDetails.name} | ${followup.plan_name} | ${followup.phone_number} | ${this.propertyDetails._id}`);
        const baseUrl = "https://calendly.com/diana-citywisesoftware/30min";
        return `${baseUrl}?name=${name}&email=${email}&a1=${a1}`;
    }

    saveFollowup(): void {
        if (this.newFollowupForm.invalid) {
            this.newFollowupForm.markAllAsTouched();
            return;
        }
        const newFollowup = this.newFollowupForm.value;
        this.calendlyLink = this.generateCalendlyLink(newFollowup);
        this.showLinkDialog = true;
        this.displaySidebar = false;
        this.onFilterChange();
    }

    getAllFollowups(event: any): void {
        if (this.filters.appointmentDate && this.filters.appointmentDate[1] == null) {
            return;
        }
        const page = Math.floor(event.first / event.rows) + 1;
        const limit = event.rows;

        const queryParams = {
            page,
            limit,
            sortField: event.sortField,
            sortOrder: event.sortOrder,
            filters: JSON.stringify(this.filters)
        };

        this.propertyService.getAllFollowups(queryParams).subscribe({
            next: (response) => {
                this.followUps = response.data;
                this.totalRecords = response.total;
                this.currentPage = page - 1;
            },
            error: () => {
                console.error('Error fetching followUps');
            },
        });
    }

    onFilterChange(): void {
        this.getAllFollowups({
            first: this.currentPage * this.rowsPerPage,
            rows: this.rowsPerPage,
            sortField: this.sorting.field,
            sortOrder: this.sorting.order
        });
    }

    onDateChange(event: any) {
        if (!event) {
            this.filters.appointmentDate = null;
            this.onFilterChange();
        } else {
            this.onFilterChange();
        }
    }

    onSorting(event: any): void {
        this.sorting.field = event.field;
        this.sorting.order = event.order;
        this.getAllFollowups({
            first: this.currentPage * this.rowsPerPage,
            rows: this.rowsPerPage,
            sortField: this.sorting.field,
            sortOrder: this.sorting.order
        });
    }

    openSidebar(): void {
        this.displaySidebar = true;
        this.newFollowupForm.reset();
    }

    cancelAddFollowup(): void {
        this.showCancelDialog = true;
    }

    confirmCancelAdd(): void {
        this.displaySidebar = false;
        this.showCancelDialog = false;
    }

    declineCancel(): void {
        this.showCancelDialog = false;
    }

    confirmDeleteFollowup(followup: any): void {
        this.followupToDelete = followup;
        this.showDeleteDialog = true;
    }

    deleteFollowup(): void {
        if (!this.followupToDelete) return;
        this.propertyService.deleteFollowup(this.followupToDelete._id).subscribe({
            next: (res: any) => {
                this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Followup deleted successfully' });
                this.showDeleteDialog = false;
                this.onFilterChange();
            },
            error: (err: any) => {
                console.error('Error deleting followup', err);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not delete followup' });
                this.showDeleteDialog = false;
            }
        });
    }

    cancelDelete(): void {
        this.showDeleteDialog = false;
        this.showCancelDialog = false;
        this.cancelTourDialog = false;
        this.isCancelling = false;
    }

    onDialogClose(): void {
        this.visible = false;
        this.selectedTour = null;
        this.onFilterChange();
    }

    showDialogForEdit(position: 'right', tour: any): void {
        this.position = position;
        this.selectedTour = tour;
        this.visible = true;
        this.headerText = "Update";
    }

    showDialogForCreate(position: 'right'): void {
        this.position = position;
        this.selectedTour = null;
        this.visible = true;
        this.headerText = "Create";
    }

    onClickInfoButton(tour: any) {
        this.selectedTour = { ...tour, messages: [] };
        this.isOpen = true;
        this.isLoading = true;
        this.isSystemConversation = true;
        this.templateService.getSystemConversation(tour._id, ConversationRole.SYSTEM, ConversationRole.RESIDENT).subscribe({
            next: (response) => {
                if (response?.tour) {
                    if (response?.auditLogs || response?.auditLogsReschedule) {
                        this.selectedTour = {
                            ...response.auditLogsReschedule,
                            ...response.auditLogs[0],
                            ...response.tour,
                            messages: response.conversations
                        };
                    }else{
                        this.selectedTour = {
                            ...response.tour,
                            messages: response.conversations
                        };
                    }
                }
                else {
                    this.selectedTour.messages = response.conversations;
                }
                this.isLoading = false;
            },
            error: () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load messages.'
                });
                this.isLoading = false;
            },
            complete: () => {
                this.isLoading = false;
            }
        });
    }

    fetchSpecificConversationNew(event: { conversationFrom: string; conversationTo: string }) {
        this.isLoading = true;

        const roles = [event.conversationFrom, event.conversationTo];
        const hasSystem = roles.includes(ConversationRole.SYSTEM);
        const hasResident = roles.includes(ConversationRole.RESIDENT);
        const hasVisitor = roles.includes(ConversationRole.VISITOR);

        this.isSystemConversation = false;
        if (hasSystem && hasResident && !hasVisitor) {
            this.isSystemConversation = true;
        } else if (hasSystem && hasVisitor && hasResident) {
            this.isSystemConversation = true;
        } else if (hasSystem && hasVisitor && !hasResident) {
            this.isSystemConversation = true;
        }

        // Petrie/Lead tab: merge Twilio conversations with textbot chatbot logs
        if (hasSystem && hasVisitor && !hasResident) {
            forkJoin({
                twilio: this.templateService.getSystemConversation(
                    this.selectedTour._id,
                    event.conversationFrom,
                    event.conversationTo
                ),
                chatbot: this.chatLogService.getLogsByPhone(this.selectedTour.phone_number)
            }).subscribe({
                next: ({ twilio, chatbot }) => {
                    const twilioMsgs: any[] = twilio?.conversations ?? [];

                    const chatbotMsgs = (chatbot?.history ?? []).map((msg: any) => ({
                        message: msg.content,
                        fromRole: msg.type === 'ai' ? ConversationRole.SYSTEM : ConversationRole.VISITOR,
                        createdAt: msg.time,
                        scheduleNumber: 1,
                        isTextbot: msg.type === 'ai'
                    }));

                    const allMessages = [...twilioMsgs, ...chatbotMsgs]
                        .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());

                    if (twilio?.tour) {
                        this.selectedTour = {
                            ...(twilio.auditLogsReschedule ?? {}),
                            ...(twilio.auditLogs?.[0] ?? {}),
                            ...twilio.tour,
                            messages: allMessages
                        };
                    } else {
                        this.selectedTour = { ...this.selectedTour, messages: allMessages };
                    }
                    this.isLoading = false;
                },
                error: () => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to load messages.'
                    });
                    this.isLoading = false;
                }
            });
            return;
        }

        this.templateService.getSystemConversation(
            this.selectedTour._id,
            event.conversationFrom,
            event.conversationTo
        ).subscribe({
            next: (response) => {
                if (response?.tour) {
                    if (response?.auditLogs || response?.auditLogsReschedule) {
                        this.selectedTour = {
                            ...response.auditLogsReschedule,
                            ...response.auditLogs[0],
                            ...response.tour,
                            messages: response.conversations
                        };
                    }else{
                        this.selectedTour = {
                            ...response.tour,
                            messages: response.conversations
                        };
                    }
                }
                else {
                    this.selectedTour.messages = response.conversations;
                }
                this.isLoading = false;
            },
            error: () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load messages.'
                });
                this.isLoading = false;
            },
            complete: () => {
                this.isLoading = false;
            }
        });
    }



    fetchSpecificConversation(event: { conversationOf: string }) {
        this.isLoading = true;
        let observable;
        const conversationOf = event.conversationOf === ConversationRole.SYSTEM;
        if (conversationOf) {
            this.isSystemConversation = true;
            observable = this.templateService.getSystemConversation(this.selectedTour._id, ConversationRole.SYSTEM, ConversationRole.SYSTEM);
        } else {
            this.isSystemConversation = false;
            observable = this.templateService.getResidentVisitorConversation(this.selectedTour._id);
        }

        observable.subscribe({
            next: (response) => {
                this.selectedTour.messages = response;
                this.isLoading = false;
            },
            error: () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load messages.'
                });
                this.isLoading = false;
            },
            complete: () => {
                this.isLoading = false;
            }
        });
    }


    // Block on typing
    blockSpecialChars(event: KeyboardEvent) {
        console.log("BLOCK typing");
        if (this.blockSpecialCharsPattern.test(event.key)) {
            event.preventDefault();
        }
    }

    // Block on paste
    blockSpecialCharsOnPaste(event: ClipboardEvent) {
        console.log("BLOCK PASTE");
        const pasteData = event.clipboardData?.getData('text') || '';
        if (this.blockSpecialCharsPattern.test(pasteData)) {
            event.preventDefault();
        }
    }

    // Block on drop
    blockSpecialCharsOnDrop(event: DragEvent) {
        console.log("BLOCK Drop");
        const dropData = event.dataTransfer?.getData('text') || '';
        if (this.blockSpecialCharsPattern.test(dropData)) {
            event.preventDefault();
        }
    }

    // Final cleanup in case something sneaks in
    sanitizeInput(event: Event) {
        console.log("SANITIZE INPUT");
        const input = event.target as HTMLInputElement;
        if (this.blockSpecialCharsPattern.test(input.value)) {
            input.value = input.value.replace(this.blockSpecialCharsPattern, '');
        }
    }

    confirmCancelTour(followup: any): void {
        this.cancelTourDialog = true;
        this.tourToCancel = followup;
        this.isCancelling = false;
    }

    cancelTour(): void {
        if (!this.tourToCancel) return;
        this.isCancelling = true;
        const payload = {
            performedBy: this.userInfo.user_id,
            performerName: this.userInfo.fullname,
            performerEmail: this.userInfo.email,
            channel: TourChannel.PORTAL
        }
        this.tourService.cancelTour(this.tourToCancel._id, payload).subscribe({
            next: (res: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: `Tour is ${TourStatus.CANCELLED} successfully`,
                });
                this.tourToCancel.tourStatus = TourStatus.CANCELLED;
                this.onFilterChange();
                setTimeout(() => {
                    this.cancelTourDialog = false;
                    this.isCancelling = false;
                }, 500);
            },
            error: (error: any) => {
                const errorMessage = error?.error?.message || 'Failed to cancel tour!';
                this.messageService.add({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: errorMessage 
                });
                setTimeout(() => {
                    this.cancelTourDialog = false;
                }, 500);
            },
            complete: () => {
                this.isCancelling = false;
            },
        });
    }

    confirmReschedule(followUp: any): void {
        this.tourService.confirmReschedule(followUp._id).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Tour reschedule confirmed. Original resident has been notified.' });
                followUp.rescheduleRequest = null;
                followUp.tourStatus = TourStatus.RESCHEDULED;
                followUp.status = TourStatus.PENDING;
            },
            error: (err: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to confirm reschedule.' });
            },
        });
    }

    sendMoreTimes(followUp: any): void {
        this.tourService.sendMoreTimes(followUp._id).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Sent', detail: 'Additional availability sent to lead.' });
            },
            error: (err: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to send availability.' });
            },
        });
    }

    tourStatus(followUp: any): { text: string; class: string } {
        const status = followUp?.status;
        const tourStatus = followUp?.tourStatus;

        // Bot-cancelled tour with a slot selected by the lead — admin must confirm
        if (tourStatus === TourStatus.CANCELLED && followUp?.rescheduleRequest) {
            return { text: 'Reschedule Pending', class: 'ReschedulePending' };
        }

        // ✅ Rescheduled as Pending visually
        if (tourStatus === TourStatus.RESCHEDULED) {
            return this.formatStatus(TourStatus.RESCHEDULED);
        }

        // if status is Active or Pending, prefer that
        if ((status === TourStatus.ACTIVE && tourStatus == TourStatus.IN_PROGRESS) || (status === TourStatus.PENDING && tourStatus !== TourStatus.CANCELLED)) {
            return this.formatStatus(status);
        }

        // otherwise, use tourStatus (completed, cancelled, etc.)
        const appendText = (status === TourStatus.PENDING && tourStatus == TourStatus.CANCELLED) ? 'Auto ' : '';
        return this.formatStatus(tourStatus, appendText);
    }

    formatStatus(value: string, appendText: string = ''): { text: string; class: string } {
        if (!value) return { text: '', class: '' };
        const formatted = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        return {
            text: appendText ? appendText + formatted : formatted,
            class: formatted
        };
    }

    showDialogForReschedule(position: 'right', tour: any): void {
        this.position = position;
        this.selectedTour = tour;
        this.visible = true;
        this.headerText = "Reschedule";
    }

    openBlackoutCalendar(): void {
        this.showBlackoutSection = true;
    }

    onTenantCalendarShow(): void {
        setTimeout(() => {
            if (this.tenantCalendarComponent) {
                const api = this.tenantCalendarComponent.getApi();
                api.setOption('timeZone', this.propTimeZone);
                api.render();
                this.loadBlackouts(this.tenantCalendarComponent);
            }
        }, 150);
    }

    private get activeCalendar(): FullCalendarComponent {
        return this.isTenant ? this.tenantCalendarComponent : this.calendarComponent;
    }

    loadBlackouts(calRef?: FullCalendarComponent) {
        const cal = calRef ?? this.activeCalendar;
        if (!cal) return;
        const calendarApi = cal.getApi();
        calendarApi.removeAllEvents(); // clear old events
        this.blackoutService.getBlackouts(this.propertyId).subscribe({
            next: (res: any) => {
                this.blackouts = res;
                
                // Map blackouts to FullCalendar events
                // this.calendarOptions.events =  this.blackouts.map((b: any) => {
                //     const startInPropTZ = moment.tz(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm', 'UTC').tz(this.propTimeZone).format('HH:mm');
                //     const endInPropTZ = moment.tz(`${b.date} ${b.endTime}`, 'MM/DD/YYYY HH:mm', 'UTC').tz(this.propTimeZone).format('HH:mm');
                //     console.log('startInPropTZ', startInPropTZ)
                //     console.log('endInPropTZ', endInPropTZ)
                //     return {
                //         title: b.reasonText ? `Unavailable: ${b.reasonText}` : 'Unavailable',
                //         start: startInPropTZ,
                //         end: endInPropTZ,
                //         allDay: b.isFullDay,
                //         display: 'background',       // shaded background
                //         backgroundColor: '#ffcccc',  // visual color
                //         borderColor: '#ff6666',
                //         extendedProps: {
                //             id: b._id,
                //             reasonType: b.reasonType,
                //             reasonText: b.reasonText,
                //             isFullDay: b.isFullDay,
                //             startTime: startInPropTZ,
                //             endTime: endInPropTZ,
                //             date: b.date,
                //         }
                //     };
                // });
                
                // Remove all existing event sources
                calendarApi.getEventSources().forEach(src => src.remove());

                // Group blackouts by date
                const byDate = new Map<string, any[]>();
                this.blackouts.forEach(b => {
                    if (!byDate.has(b.date)) byDate.set(b.date, []);
                    byDate.get(b.date)!.push(b);
                });

                const events: any[] = [];

                byDate.forEach((blackoutsOnDate, dateStr) => {
                    const [month, day, year] = dateStr.split('/').map(Number);

                    // Always one background event per date (for shading)
                    const bgStart = new Date(Date.UTC(year, month - 1, day));
                    const bgEnd   = new Date(Date.UTC(year, month - 1, day + 1));

                    events.push({
                        id: `bg-${dateStr}`,
                        start: bgStart,
                        end: bgEnd,
                        allDay: true,
                        display: 'background',
                        classNames: ['blackout-event'],
                        extendedProps: { isBackground: true }
                    });

                    // One block event per blackout for label + delete button
                    // Landlord calendar only shows landlord blackouts (no userId); tenant blackouts are not relevant here
                    const blockCandidates = this.isTenant ? blackoutsOnDate : blackoutsOnDate.filter(b => !b.userId);
                    blockCandidates.forEach((b, index) => {
                        events.push({
                        id: b._id,
                        start: bgStart,
                        end: bgEnd,
                        allDay: true,
                        display: 'block',
                        classNames: ['blackout-event-label'],
                        title: !b.userId
                            ? b.isFullDay
                                ? 'Blocked by Admin (Full Day)'
                                : `Blocked by Admin ${this.formatBlackoutTime(b)}`
                            : b.isFullDay
                                ? 'Unavailable (Full Day)'
                                : `Unavailable ${this.formatBlackoutTime(b)}`,
                            // Full-day → background shading; partial → block so multiple slots stack visibly
                        extendedProps: {
                            blackout: b // 🔥 KEEP ORIGINAL RECORD
                        }
                        });
                    });
                });
                // force refresh
                calendarApi.addEventSource(events);

                console.log('Calendar API ready with events: ', events);
            },
            error: (err: any) => {
                console.error('Failed to load blackouts', err);
            }
        });
    }

    // Helper to format time for display
    formatBlackoutTime(b: any): string {
        if (!b.startTime || !b.endTime) return '';
        const start = moment(b.startTime, 'HH:mm').format('h:mm A');
        const end   = moment(b.endTime,   'HH:mm').format('h:mm A');
        return `${start}–${end}`;
    }

    onBlackoutDateSelect(dateString: string) {
        this.selectedBlackoutDate = dateString;

        if (this.isTenant) {
            // Tenant always creates new — no edit mode (multiple slots allowed)
            this.editingBlackoutId = null;
            this.isFullDayBlackout = false;
            this.blackoutReasonText = '';
            const now = new Date();
            const propertyCurrentTime = toZonedTime(now, this.propTimeZone);
            this.blackoutStartTime = this.roundToNearest30Minutes(propertyCurrentTime);
            this.blackoutEndTime = this.roundToNearest30Minutes(addHours(propertyCurrentTime, 1));
            this.showBlackoutDialog = true;
            return;
        }

        const blackout = this.blackouts.find(b => b.date === dateString && !b.userId);
        if (blackout) {
            console.log('blackout', blackout)
            // Editing existing blackout
            this.editingBlackoutId = blackout._id;
            this.isFullDayBlackout = blackout.isFullDay;
            this.blackoutReasonText = blackout.reasonText || '';

            if (!this.isFullDayBlackout && blackout.startTime && blackout.endTime) {
                const [sh, sm] = blackout.startTime.split(':').map(Number);
                const [eh, em] = blackout.endTime.split(':').map(Number);
                const [month, day, year] = blackout.date.split('/').map(Number);
                this.blackoutStartTime = new Date(year, month - 1, day, sh, sm, 0);
                this.blackoutEndTime   = new Date(year, month - 1, day, eh, em, 0);
            } else {
                const now = new Date();
                const propertyCurrentTime = toZonedTime(now, this.propTimeZone);

                // Snap to nearest 30 minutes
                const startTime = this.roundToNearest30Minutes(propertyCurrentTime);
                this.blackoutStartTime = startTime;

                const endTime = this.roundToNearest30Minutes(addHours(propertyCurrentTime, 8));
                this.blackoutEndTime = endTime; // end = start + 8 hours
            }

        } else {
            this.editingBlackoutId = null;
            this.isFullDayBlackout = true;
            this.blackoutReasonText = '';

            const now = new Date();
            const propertyCurrentTime = toZonedTime(now, this.propTimeZone);

            // Snap to nearest 30 minutes
            const startTime = this.roundToNearest30Minutes(propertyCurrentTime);
            this.blackoutStartTime = startTime;

            const endTime = this.roundToNearest30Minutes(addHours(propertyCurrentTime, 8));
            this.blackoutEndTime = endTime; // end = start + 8 hours
        }

        this.showBlackoutDialog = true;
    }

    roundToNearest30Minutes(date: Date): Date {
        const minutes = date.getMinutes();
        const remainder = minutes % 30;
        if (remainder === 0) return date;

        // Round up to next 30-minute mark
        const diff = 30 - remainder;
        const roundedDate = new Date(date);
        roundedDate.setMinutes(minutes + diff);
        roundedDate.setSeconds(0, 0);
        return roundedDate;
    }

    formatDateForInput(date: Date | string): string {
        // If it's already a string in YYYY-MM-DD, return as is
        if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
            return date;
        }

        // Convert Date object to MM/DD/YYYY string
        const d = date instanceof Date ? date : new Date(date);
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        const year = d.getFullYear();

        return `${month}/${day}/${year}`;
    }

    saveBlackout() {
        if (!this.selectedBlackoutDate) return;
        
        console.log('this.selectedBlackoutDate', this.selectedBlackoutDate)

        const payload: any = {
            date: this.selectedBlackoutDate,
            isFullDay: this.isFullDayBlackout,
            reasonText: this.blackoutReasonText,
            propTimeZone: this.propTimeZone,
        };

        if (!this.isFullDayBlackout) {
            const formatTime = (date: Date | null): string => {
                if (!date) return '';
                const hours = date.getHours().toString().padStart(2, '0');
                const minutes = date.getMinutes().toString().padStart(2, '0');
                return `${hours}:${minutes}`;
            };
            payload.startTime = formatTime(this.blackoutStartTime);
            payload.endTime = formatTime(this.blackoutEndTime);
        }
        console.log('payload', payload)
        let request$;
        if (this.editingBlackoutId) {
            request$ = this.blackoutService.updateBlackout(this.editingBlackoutId, payload);
        } else {
            request$ = this.blackoutService.createBlackout(this.propertyId, payload);
        }

        request$.subscribe({
            next: () => {
                this.loadBlackouts();
                this.showBlackoutDialog = false;
            },
            error: (err) => {
                const message = err?.error?.message || 'Failed to save blackout.';
                this.messageService.add({
                    severity: 'error',
                    summary: 'Blackout Error',
                    detail: message,
                    life: 5000,
                });
            }
        });
    }

    deleteBlackout(id: string) {
        if (!id) return;

        this.blackoutService.deleteBlackout(id).subscribe({
            next: () => {
                // Re-fetch all blackouts so hidden slots (e.g. after deleting full-day) reappear
                this.loadBlackouts();
                this.showBlackoutDialog = false;
            },
            error: (err) => {
                console.error('Error deleting blackout', err);
            }
        });
    }

    toDate(date: any): Date {
        if (!date) return new Date();
        return date instanceof Date ? date : new Date(date);
    }

    isBlackoutDate(date: any): boolean {
        const d = date instanceof Date ? date : new Date(date);
        return this.blackouts.some(b => new Date(b.date).toDateString() === d.toDateString());
    }

    getBlackoutTooltip(blackout: any): string {
        if(blackout?.blackout){
            let tooltip = `Blackout Date: ${blackout?.blackout?.date}`;
            
            if (!blackout?.blackout?.isFullDay && blackout?.blackout?.startTime && blackout?.blackout?.endTime) {
                const start = moment(blackout?.blackout?.startTime, 'HH:mm').format('hh:mm A');
                const end   = moment(blackout?.blackout?.endTime,   'HH:mm').format('hh:mm A');

                tooltip += `\nTime: ${start} - ${end}`;
            }

            if (blackout?.blackout?.reasonText) {
                tooltip += `\nReason: ${blackout?.blackout?.reasonText}`;
            }
            return tooltip;
        }
        return '';
    }

    normalizeTime(date: Date, interval: number): Date {
        const d = new Date(date);

        const minutes = d.getMinutes();
        const rounded = Math.floor(minutes / interval) * interval;

        d.setMinutes(rounded);
        d.setSeconds(0);
        d.setMilliseconds(0);

        return d;
    }

    onTimeChange(event: any) {
        if (!event?.value) return;

        const snapped = this.normalizeTime(
            event.value,
            30
        );

        event.value.setTime(snapped.getTime());
    }

    setBlackoutTimes(blackout: any) {
        // Convert UTC to New York time for display
        this.blackoutStartTime = toZonedTime(new Date(blackout.startTime), this.propTimeZone);
        this.blackoutEndTime   = toZonedTime(new Date(blackout.endTime), this.propTimeZone);
    }

    showDeleteBlackoutDialog(blackoutId: string): void {
        this.blackoutIdToDelete = blackoutId;
        this.showBalckoutDeleteDialog = true;
    }

    cancelDeleteBlackout(): void {
        this.showBalckoutDeleteDialog = false;
        this.blackoutIdToDelete = null;
    }

    confirmDeleteBlackout(): void {
        if (!this.blackoutIdToDelete) return;

        this.deleteBlackout(this.blackoutIdToDelete);

        this.cancelDeleteBlackout();
    }

    getLatestNote(followUp: any): string {
        const notes = followUp.tourMeta?.internalNotes;
        if (notes?.length > 0) {
            return notes.find((n: InternalNote) => n.latest)?.text || '';
            // const latest = [...notes].sort(
            // (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
            // ).pop();

            // return latest?.text || '';
        }
        return '';
    }
}